// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610062236/js/" + chunkId + "." + {"44":"5125f277","225":"f63d68cb","481":"f0701b3b","486":"ed447a41","770":"264621e5"}[chunkId] + ".0.9005252055809723.chunk.js";
};